module.exports = __webpack_public_path__ + "media/svg/web-4f623bd0.svg";